import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path, Rect } from "react-native-svg";

export const IconStudioDisplay1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconStudioDisplay1"><Path d="M9 17H15V20.25C15 20.6642 14.6642 21 14.25 21H9.75C9.33579 21 9 20.6642 9 20.25V17Z" fill="currentColor"/><Rect x="2" y="3" width="20" height="13" rx="0.75" fill="currentColor"/></CentralIconBase>;
});

export default IconStudioDisplay1;
